<template>
  <i-select
    :value="value"
    :loading="is_loading"
    :clearable="true"
    :filterable="true"
    :remote="true"
    :remote-method="debounce_save"
    v-on="$listeners"
  >
    <i-option v-for="m in mailings" :key="m.id" :value="m.id" :label="m.name" />
  </i-select>
</template>

<script>
  import { MailingListService } from '@mailer/services/MailingListService';
  import debounce from 'lodash-es/debounce';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data() {
      return {
        is_loading: false,
        mailings: []
      };
    },

    methods: {
      search: function(query) {
        this.is_loading = true;
        MailingListService.getSelect({ name: query, limit: 10 })
          .then(res => (this.mailings = res))
          .finally(() => (this.is_loading = false));
      },

      debounce_save: debounce(function(query) {
        this.search(query);
      }, 300)
    }
  };
</script>
